import ReactModal from "react-modal";

export const CreateBadgeModal = ({
  showCreateModal,
  setShowCreateModal,
}: {
  showCreateModal: boolean;
  setShowCreateModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <ReactModal
      isOpen={showCreateModal}
      onRequestClose={() => {
        setShowCreateModal(false);
      }}
      contentLabel="Create Badge Barcode"
      className="Modal"
      overlayClassName="Overlay"
    >
      <h2>Create Barcode Badge</h2>
    </ReactModal>
  );
};

export default CreateBadgeModal;
